import DashboardFirebaseConfig from "../utils/dashboardFirebaseConfig";

const FirebaseConfigByEnvironment = () => {

    let firebase_config;
    firebase_config = DashboardFirebaseConfig

    if (Object.keys(firebase_config).length === 0) {
        throw 'firebase_client_config*.json is empty! Please run `make get-client-config` and fill in the appropriate values';
    }
    return firebase_config;
}

export default FirebaseConfigByEnvironment;